import React, { memo } from 'react';
import { SEARCH_SUGGESTIONS_LISTBOX_ID } from './utils/search-suggestions-aria';

type SearchSuggestionsListboxProps = React.PropsWithChildren<{
  'aria-label': string;
}>;

export const SearchSuggestionsListbox = memo<SearchSuggestionsListboxProps>(
  ({ children, 'aria-label': ariaLabel }) => (
    <div
      id={SEARCH_SUGGESTIONS_LISTBOX_ID}
      role="listbox"
      aria-label={ariaLabel}
      aria-multiselectable={false}
    >
      {children}
    </div>
  ),
);
